export default {
    namespaced: true,
    composite_alarm_rule: {
        title: "Composite alarm rule",
        is_active: "Is active",
        name: "Name",
        description: "Description",
        type_alarm: "Type alarm",
        alarm_level: "Alarm level",
        day_scope: "Day of operation",
        evaluation_mode: "Evaluation mode",
        start_time: "Start time",
        end_time: "End time",
        created_at: "Created at",
        updated_at: "Updated at",
        deleted: "Rule deleted successfully",
        delete_error: "The rule could not be deleted",
        save: "Save",
        created: "Rule created successfully",
        updated: "Rule updated successfully",
        save_error: "The rule could not be saved",
        load_error: "The rule could not be loaded",
        select_type: "Select a type",
        select_level: "Select a level"
    },
    general: {
        title: "General information",
        active_rule: "Active rule",
        rule_name: "Rule name",
        tenant: "Tenant",
        panel: "Panel",
        all_panels: "All panels of the tenant",
        description: "Description"
    },
    programming: {
        title: "Programming",
        evaluation_mode: "Evaluation mode",
        select_mode: "Select a mode",
        mode_immediate: "Window",
        mode_delayed: "After",
        activation_time: "Activation time",
        seconds: "Seconds",
        day_operation: "Day of operation",
        all_days: "All days",
        business_days: "Business days",
        business_days_and_saturdays: "Business days and saturdays",
        non_business_days_and_holidays: "Non-business days and holidays",
        applies_schedule: "Apply schedule",
    },
    activation_condition: {
        add_condition: "Add condition",
        title: "Activation condition",
        empty: "You haven't added any conditions yet.",
        condition: "Condition",
        remove: "Remove",
        types: "Types",
        types_count: "{count} type(s)",
        device_type: "Device type",
        details: "Details",
        alarm_type: "Type alarm",
        acronym: "Acronym",
        ocurrencies: "Occurrences",
        devices: "Devices",
        granular_condition: "Granular condition",
        general_condition: "General condition",
        granular: "Granular",
        general: "General",
        device: "Device",
        device_tag: "Device tag",
        device_tag_placeholder: "Resolved when the device is selected",
        without_tag: "no tag",
        cancel: "Cancel",
        add: "Add",
        needs_panel: "Select a panel in the rule to choose areas and devices.",
        area: "Area",
        zone: "Zone",
        area_without_zones: "This area has no zones",
        base_alarms: "Base alarms",
        alarm_type_hint_granular: "Alarms based on the device tag",
        alarm_type_hint_general: "Any alarm type",
        occurrences_hint: "Applies to all types in this condition",
        select_area: "Select an area",
        select_zone: "Select a zone",
        select_device: "Select a device",
        select_alarm_type: "Select an alarm type",
        device_types: {
            area_zone: "Area - Zone",
            zone24h: "Zone 24h",
            door: "Door",
            output: "Output"
        },
    }
};